export const FETCH_USERS = '/users';
export const ADD_USER = '/users';
export const REMOVE_USER = (id: number) => `/users/${id}`;
export const REMOVE_USER_PROVIDER_MAP = '/providers/removeMap';
